import React, { PropsWithChildren } from 'react';

import FormattedValidation from '@skippay/core/components/FormattedValidation';
import { be, bm } from '@skippay/core/utils/classUtils';

import './index.sass';

const MODULE_NAME = 'AuthField';

interface Props {
	error?: JSX.Element;
	errorFormat?: (error: Props['error']) => JSX.Element;
	hasError?: boolean;
	isTouched?: boolean;
	label?: JSX.Element;
	noSpacingBottom?: boolean;
	noVerticalOffset?: boolean;
	wide?: boolean;
}

function AuthField(props: PropsWithChildren<Props>): JSX.Element {
	const {
		wide,
		label,
		noVerticalOffset,
		isTouched,
		hasError,
		error,
		errorFormat,
		children,
		noSpacingBottom,
	} = props;

	return (
		<div
			className={bm(MODULE_NAME, {
				noSpacingBottom,
				withError: isTouched && hasError,
				withExclamation: isTouched && hasError,
				wide,
				noVerticalOffset,
			})}
		>
			<label data-clarity-mask="true" className={be(MODULE_NAME, 'label')}>
				{label && <span className={be(MODULE_NAME, 'labelText')}>{label}</span>}

				{children}

				{isTouched && hasError && (
					<div className={be(MODULE_NAME, 'error')}>
						{errorFormat ? errorFormat(error) : <FormattedValidation value={error} />}
					</div>
				)}
			</label>
		</div>
	);
}

export default AuthField;
